export type AddNotesModel = {
  note: string;
  isPrivateNote: boolean;
};

export const DefaultAddNotesModel = {
  note: "",
  isPrivateNote: true
};
